import styledC from 'styled-components';

import Box, { IBoxProps } from '../Box';

const Flex: React.FC<IBoxProps> = styledC(Box)`
  display: flex;
`;

export default Flex;
